import "amazon-connect-streams";
import React, {useCallback, useEffect, useState} from "react";
import Text from "aws-northstar/components/Text";
import Box from "aws-northstar/layouts/Box";
import Container from "aws-northstar/layouts/Container";
import ColumnLayout, { Column } from 'aws-northstar/layouts/ColumnLayout';
import Stack from 'aws-northstar/layouts/Stack';
import { useConnected, useDestroy, useRefresh } from "../hooks";
import { genLogger } from "../lib";

const name = "CustomerInfo";
const { log, error } = genLogger(name);

const formatData = (attr = {}) => {
  attr.VoiceSignature_Complete = attr.VoiceSignature_Complete || {};
  attr.VoiceSignature_Agree = attr.VoiceSignature_Agree || {};

  const VoiceSignature_Complete = attr.VoiceSignature_Complete.value;
  const VoiceSignature_Agree = attr.VoiceSignature_Agree.value;
  return {
    VoiceSignature_Complete,
    VoiceSignature_Agree
  };
};

const keyNameMappings = {
  VoiceSignature_Complete: 'Voice Signature Complete?',
  VoiceSignature_Agree: 'Voice Signature Agreed?'
};

const CustomerInfo = () => {
  const [data, setData] = useState({
    VoiceSignature_Complete: '-',
    VoiceSignature_Agree: '-'
  });

  const onConnected = useCallback((c) => {
    try {
      const attr = c.getAttributes();
      log("attr: ", attr);
      if (attr === null) {
        throw new Error("attr was null");
      }

      log("formatting data");
      const d = formatData(attr);
      log("setting data if not empty");
      if (Object.keys(d).length > 0) {
        log("setting data...", d);
        setData(d);
      }
    } catch (e) {
      error("couldn't set data", e);
    }
  }, []);
  useConnected(onConnected);

  const onRefresh = useCallback((c) => {
    try {
      const attr = c.getAttributes();
      log("attr: ", attr);
      if (attr === null) {
        throw new Error("attr was null");
      }

      log("formatting data");
      const d = formatData(attr);
      log("setting data if not empty");
      if (Object.keys(d).length > 0) {
        log("setting data...", d);
        setData(d);
      }
    } catch (e) {
      error("couldn't set data", e);
    }
  }, []);
  useRefresh(onRefresh);

  const onDestroy = useCallback(() => {
    try {
      log("destroyed, emptying data");
      setData({
        VoiceSignature_Complete: '-',
        VoiceSignature_Agree: '-'
      });
    } catch (e) {
      error("couldn't empty data", e);
    }
  }, []);
  useDestroy(onDestroy);

  useEffect(() => {
    let isCancelled = false;
    const asyncFunc = async () => {
      try {
        
      } catch (e) {
        if (!isCancelled) error(e);
      }
    };
    asyncFunc();
    return () => (isCancelled = true);
  }, [data]);

  return (
      <div>
        <Box bgcolor="#414141" color="white" fontSize="18px" textAlign="center" height="35px" padding="8px" m={0}>
         Contact Attributes
        </Box>
        <Container>
          <ColumnLayout>
            <Column key="column1">
              <Stack className="contact-attributes">
                {
                  Object.keys(data).map((key, index) => {
                    return  <Text color="primary" key={index}>{keyNameMappings[key]}</Text>;
                  })
                }
              </Stack>
            </Column>
            <Column key="column2">
              <Stack className="contact-attributes">
                {
                  Object.keys(data).map((key, index) => {
                    return <Text color="primary" key={index}>{data[key] || "-"}</Text>;
                  })
                }
              </Stack>
            </Column>
          </ColumnLayout>
        </Container>
      </div>
  );
};

export default CustomerInfo;
